import {Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import FormControl from "@material-ui/core/FormControl/FormControl";
import RenderMetadataField from "../../common/RenderMetadataField";
import PropTypes from "prop-types";
import React from "react";
import {withSnackbar} from "notistack";
import {withStyles} from "@material-ui/core/styles";

const styles = theme => ({});

function MetadataPanel(props) {

    //Render fields for each metadata item on the document
    const debug = window.location.pathname.toLowerCase().includes("debug");
    debug && console.log ('MetadataPanel props: ', props);
    const classes = props.classes;

    let metadataFields = props.metadataFields;
    let formValues = {};
    if (metadataFields && metadataFields.length > 0){
        Object.entries(metadataFields).forEach(entry => {
            formValues[entry[1].templateKey + "~" + entry[1].metadataKey] = entry[1].value;
        });
    }

    let editableFields = [];

    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant={"h6"} color={"textPrimary"} className={classes.sidePanelHeader}>Metadata</Typography>
                {
                    props.isFetchingMetadata ?
                        <div className={classes.sidePanelHeader}><LinearProgress variant={"indeterminate"} color={"secondary"}/></div>:
                        props.fetchError &&
                        <Typography variant={"body2"} color={"textPrimary"} className={classes.sidePanelHeader}>
                            Error retrieving metadata
                        </Typography>
                }
            </Grid>
            {
                metadataFields && Array.isArray(metadataFields) && metadataFields.length > 0 &&
                <Grid item xs={12}>
                    <List>
                        {
                            metadataFields.map( field => {
                                editableFields.push(field.templateKey + "~" + field.metadataKey)
                                return(
                                    <ListItem key={field.templateKey + field.metadataKey}>
                                        <FormControl fullWidth  style={{paddingBottom: '10px'}} key={"fc" + field.templateKey + "~" + field.metadataKey}>
                                            <RenderMetadataField
                                                fieldValue={field.value ? field.value : null}
                                                handleOnChange={props.handleOnChangeMetadata}
                                                metadataConfig={props.metadataConfig}
                                                optionsConfig={props.optionsConfig}
                                                metadataKey={field.metadataKey}
                                                templateKey={field.templateKey}
                                                forceDisable={props.isFetchingMetadata || !props.hasEditAccess || field.readOnly}
                                                usage={"edit"}
                                                formValues={formValues}
                                            />
                                        </FormControl>
                                    </ListItem>)
                            })
                        }
                    </List>
                </Grid>
            }
        </Grid>
    )
}

MetadataPanel.propTypes = {
    classes: PropTypes.object.isRequired,
    isFetchingMetadata: PropTypes.bool.isRequired,
    fetchError: PropTypes.bool.isRequired,
    metadataFields: PropTypes.object.isRequired,
    metadataConfig: PropTypes.object.isRequired,
    optionsConfig: PropTypes.object.isRequired,
    handleOnChangeMetadata: PropTypes.func.isRequired,
    hasEditAccess: PropTypes.bool.isRequired
};

export default withSnackbar(withStyles(styles, { withTheme: true} )(MetadataPanel));